<template>
  <section class="sign-cancel-handle">
    <p class="title">{{ $t('host.k_592001') }}</p>
    <p class="des">{{ $t('host.k_592002', [pushTime.substring(5)]) }}</p>
    <p class="warn-tip">{{ $t('host.k_592008') }}</p>
    <vh-button class="cancel_btn" type="primary" size="medium" round @click="cancelSign">
      {{ $t('host.k_592004') }}
    </vh-button>
  </section>
</template>
<script>
  export default {
    name: 'cancelHandle',
    props: { pushTime: String },
    methods: {
      cancelSign() {
        this.$vhConfirm(this.$t('host.k_592005'), this.$t('host.k_592006'), {
          confirmButtonText: this.$t('host.k_592007'),
          cancelButtonText: this.$t('host.k_592004'),
          roundButton: true
        }).then(() => {
          this.$emit('cancelSign');
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  .sign-cancel-handle {
    position: relative;
    width: calc(100% - 60px);
    height: 440px;
    left: 30px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    padding: 0 12px;
    box-sizing: border-box;

    .title {
      padding-top: 190px;
      margin-bottom: 20px;
      font-weight: 500;
      text-align: center;
    }

    .warn-tip {
      color: #fb2626;
      margin-top: 20px;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    }

    .cancel_btn {
      position: absolute;
      width: 160px;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
</style>
